function openSizeGuideModal(productTags) {
  const SIZE_GUIDE_MODAL_WIDTH = "520px";
  const SIZE_GUIDE_MODAL_HEIGHT = "300px";
  const contentRenderFunc = getContentRenderFunc(productTags);
  if (contentRenderFunc === undefined) {
    console.error("No size guide content found for product tags:", productTags);
    return;
  }

  const modalReference = openModal(
    SIZE_GUIDE_MODAL_WIDTH,
    SIZE_GUIDE_MODAL_HEIGHT,
  );

  modalReference.classList.add("size-guide-modal");

  contentRenderFunc(modalReference);
}

function getContentRenderFunc(productTags) {
  let contentRenderFunc = undefined;
  for (const tag of productTags) {
    if (contentRenderFunc !== undefined) {
      break;
    }

    const loweredTag = tag.toLowerCase();
    switch (loweredTag) {
      case "hats":
        contentRenderFunc = renderHatSizeGuideContent;
        break;
      default:
        break;
    }
  }

  return contentRenderFunc;
}

function renderHatSizeGuideContent(modalRef) {
  const tableElem = document.createElement("table");

  const tableHeaders = ["", "XS", "S", "M", "L", "XL"];
  const tableRows = [["Circumference", "55 CM", "56 CM", "57 CM", "58 CM", "59 CM"]];

  const headerRow = document.createElement("tr");
  for (const [index, header] of tableHeaders.entries()) {
    const th = document.createElement("th");
    th.classList.add("text-darker-secondary");
    th.innerText = header;
    headerRow.appendChild(th);
  }

  tableElem.appendChild(headerRow);

  for (const rowData of tableRows) {
    const row = document.createElement("tr");
    let ind = 0;
    for (const [index, cellData] of rowData.entries()) {
      const td = document.createElement("td");

      if (ind != 0) {
        td.classList.add("fw-bold");
      }
      td.innerText = cellData;
      row.appendChild(td);
      ind++;
    }

    tableElem.appendChild(row);
  }

  tableElem.classList.add("w-100");

  const titleElem = document.createElement("h4");
  titleElem.classList.add("text-uppercase", "mb-5");
  titleElem.innerHTML = "Cap Size Guide";

  modalRef.classList.add("px-3", "pt-4");
  modalRef.appendChild(titleElem);
  modalRef.appendChild(tableElem);
}

function appendSplitDivSizeGuide(modalRef, elem1, elem2) {
  const splitDiv = document.createElement("div");
  splitDiv.classList.add("d-flex", "flex-row", "w-100", "h-100");

  elem1.classList.add("w-50", "h-100");
  elem2.classList.add("w-50", "h-100");

  splitDiv.appendChild(elem1);
  splitDiv.appendChild(elem2);

  modalRef.appendChild(splitDiv);
}
